import { useRef } from 'react';
// import InnerHTML from 'dangerously-set-html-content';

import { useComponentAnimation } from '../VirtualArticle.hooks';
import { useLayoutEffect } from 'yet-another-react-lightbox';

export const VirtualCustom = (props: CustomProps) => {
	const { id, bleed = false, animation, content } = props;
	const ref = useRef(null);
	const animationClasses = useComponentAnimation({
		ref,
		animation,
	});

	const classNames = [...animationClasses];
	if (bleed) {
		classNames.push('bleed');
	}

	if (!content) {
		return null;
	}

	return (
		<div id={id} ref={ref} className={classNames.join(' ')}>
			<DangrousElement markup={content} />
		</div>
	);
};

interface CustomProps {
	id: string;
	bleed: boolean;
	content: string;
	animation: any;
}

function DangrousElement({ markup }: { markup: string }) {
	const elRef = useRef<HTMLDivElement>(null);
	useLayoutEffect(() => {
		if (!elRef) return;
		const { current } = elRef;
		if (!current) return;
		const range = document.createRange();
		range.selectNode(current);
		const documentFragment = range.createContextualFragment(markup);
		current.innerHTML = '';
		current.append(documentFragment);
	}, [elRef]);
	return <div ref={elRef} dangerouslySetInnerHTML={{ __html: markup }} />;
}
